<template>
  <div class="doctor-page">
    <div class="page-container">
      <!-- 面包屑 -->
      <nav class="breadcrumb">
        <a class="bc-link" @click.prevent="goHome">首页</a>
        <span class="bc-sep">/</span>
        <span class="bc-current">医生认证</span>
      </nav>

      <!-- 认证资料卡 -->
      <div class="panel-card">
        <div class="panel-head">
          <h2 class="panel-title">医生认证资料</h2>
          <span class="panel-pill">认证说明</span>
        </div>

        <!-- 医生概要 -->
        <div class="profile-block">
          <span class="pb-avatar">{{ avatarText }}</span>
          <div class="pb-info">
            <div class="pb-name-row">
              <span class="pb-name">{{ info.doctorName || '—' }}</span>
              <span class="pb-tag">医生</span>
            </div>
          </div>
          <span class="pb-status">
            <span class="pb-dot" aria-hidden="true"></span>
            {{ statusText }}
          </span>
        </div>

        <!-- 资料表 -->
        <div class="info-table">
          <div class="it-head">
            <span class="it-col it-col-name">资料项目</span>
            <span class="it-col it-col-value">登记内容</span>
            <span class="it-col it-col-desc">资料说明</span>
          </div>
          <div class="it-row" v-for="item in infoRows" :key="item.label">
            <span class="it-col it-col-name">{{ item.label }}</span>
            <span class="it-col it-col-value">
              {{ item.value || '暂未提供' }}
              <span v-if="item.mark" class="star-mark">{{ item.mark }}</span>
            </span>
            <span class="it-col it-col-desc">{{ item.desc }}</span>
          </div>
        </div>

        <!-- 行医资格证图片 -->
        <div class="cert-block">
          <span class="cb-icon" aria-hidden="true">
            <svg viewBox="0 0 24 24" width="26" height="26" fill="none" stroke="#009798" stroke-width="1.6"
              stroke-linecap="round" stroke-linejoin="round">
              <rect x="4" y="3" width="16" height="18" rx="2" />
              <path d="M8 8h8M8 12h5" />
            </svg>
          </span>
          <div class="cb-body">
            <span class="cb-title">行医资格证图片</span>
            <span class="cb-desc">{{ info.doctorCertImageUrl ? '点击可查看证件原件图片。' : '暂未提供证件图片，无法查看原件。' }}</span>
          </div>
          <button class="cb-btn" type="button" :class="{ 'cb-btn-muted': !info.doctorCertImageUrl }"
            @click="certVisible = true">
            {{ info.doctorCertImageUrl ? '查看原图' : '暂无原图' }}
          </button>
        </div>

        <!-- 卡内底部 -->
        <!-- <div class="panel-foot">
          <p class="foot-note">资料缺失不等于审核未通过，认证结果以平台核验为准。</p>
          <span class="foot-tag">身份与执业信息</span>
        </div> -->
      </div>

      <!-- 底部提示 -->
      <!-- <div class="page-bottom">
        <p class="bottom-hint">医生资质仅用于身份核验与合规展示，请勿传播或用于其他用途。</p>
        <button class="bottom-back" type="button" @click="goPatient">
          <span>查看患者档案</span>
          <span class="bottom-back-arrow" aria-hidden="true">→</span>
        </button>
      </div> -->
    </div>

    <!-- 大图弹窗 -->
    <el-dialog :visible.sync="certVisible" title="行医资格证" width="620px" custom-class="cert-dialog" append-to-body>
      <img v-if="info.doctorCertImageUrl" :src="info.doctorCertImageUrl" class="cert-full" alt="行医资格证" />
      <div v-else class="no-cert">暂无证件图片</div>
    </el-dialog>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        info: {},
        fromPath: '',
        certVisible: false
      }
    },
    computed: {
      infoRows() {
        if (!this.info || !this.info.doctorName) return [];
        return [
          { label: "医生姓名", value: this.info.doctorName, mark: this.info.inheritor == 'Y' ? '★' : '', desc: "基础身份信息" },
          { label: "医生性别", value: this.info.doctorSex == '0' ? '女' : '男', mark: '', desc: "基础身份信息" },
          { label: "医生电话", value: this.info.doctorPhonNo, mark: '', desc: "用于联系与身份核验" },
          { label: "身份证号", value: this.info.idNo, mark: '', desc: "身份核验资料" },
          { label: "行医资格证编号", value: this.info.doctorCertNo, mark: '', desc: "执业资格资料" },
        ];
      },
      avatarText() {
        var n = this.info && this.info.doctorName ? String(this.info.doctorName) : '';
        return n ? n.charAt(0) : '医';
      },
      statusText() {
        return '认证状态待核验';
      }
    },
  created() {
      this.info = JSON.parse(this.$route.query.info)
      console.log(this.info)
    },
    methods:{
      goBack(){
          if(!this.utils.isEmptyStr(this.fromPath) && this.fromPath != '/'){
              this.$router.go(-1)
          }else{
              this.$router.replace('/')
          }
      },
      goHome() {
          this.$router.replace('/')
      },
      goPatient() {
          this.$router.push('/Contact')
      },
    },
    beforeRouteEnter(to,from,next){
        next(vm =>{
            vm.fromPath = from.path
        })
    }
  }
</script>

<style scoped>
/* ============================================================
   DoctorInfoPage — 医生认证（青绿主题 / 参考设计图）
   ============================================================ */
.doctor-page {
  min-height: 60vh;
  background: #f5f7f2;
  color: #304744;
  padding-bottom: 20px;
}

.page-container {
  max-width: 1220px;
  margin: 0 auto;
  padding: 32px 24px 40px;
}

/* ========== 面包屑 ========== */
.breadcrumb {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 16px;
  margin-bottom: 18px;
}

.bc-link {
  color: #527f77;
  cursor: pointer;
}

.bc-link:hover {
  color: #009798;
}

.bc-sep {
  color: #b6c6c1;
}

.bc-current {
  color: #304744;
  font-weight: 600;
}

/* ========== Hero ========== */
.hero-row {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 24px;
  margin-bottom: 22px;
}

.hero-brand {
  margin: 0 0 14px;
  font-size: 16px;
  font-weight: 600;
  color: #009798;
  letter-spacing: 1px;
}

.hero-title {
  margin: 0 0 12px;
  font-size: 40px;
  font-weight: 700;
  color: #304744;
  letter-spacing: 1px;
  line-height: 1.2;
}

.hero-subtitle {
  margin: 0;
  font-size: 17px;
  color: #527f77;
}

.hero-back {
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  height: 46px;
  padding: 0 22px;
  border: 1px solid #cfdcd8;
  border-radius: 12px;
  background: #fff;
  color: #304744;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
}

.hero-back:hover {
  border-color: #009798;
  color: #009798;
}

.hero-back-arrow {
  color: #009798;
  font-weight: 700;
}

/* ========== 提示条 ========== */
.notice-bar {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 16px 22px;
  margin-bottom: 26px;
  border: 1px solid #f2e4c4;
  border-radius: 14px;
  background: #fdf7e9;
}

.notice-icon {
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  border: 1.5px solid #c9a24a;
  color: #c9a24a;
  font-size: 16px;
  font-weight: 700;
}

.notice-text {
  margin: 0;
  font-size: 16px;
  line-height: 1.6;
  color: #8a6d3b;
}

/* ========== 认证资料卡 ========== */
.panel-card {
  background: #fff;
  border: 1px solid #e9efec;
  border-radius: 22px;
  padding: 30px 34px 26px;
  box-shadow: 0 10px 30px rgba(23, 61, 59, 0.06);
}

.panel-eyebrow {
  margin: 0 0 10px;
  font-size: 16px;
  font-weight: 700;
  letter-spacing: 2px;
  color: #a9bcb6;
}

.panel-head {
  display: flex;
  align-items: center;
  gap: 14px;
  margin-bottom: 22px;
}

.panel-title {
  margin: 0;
  font-size: 30px;
  font-weight: 700;
  color: #304744;
}

.panel-pill {
  margin-left: auto;
  display: inline-flex;
  align-items: center;
  padding: 9px 18px;
  border: 1px solid #b7ddd8;
  border-radius: 10px;
  background: #fff;
  color: #009798;
  font-size: 16px;
  font-weight: 600;
}

/* ========== 医生概要 ========== */
.profile-block {
  display: flex;
  align-items: center;
  gap: 18px;
  padding: 22px 24px;
  margin-bottom: 22px;
  border: 1px solid #dcebe7;
  border-radius: 18px;
  background: linear-gradient(105deg, #eaf6f3 0%, #f4faf8 100%);
}

.pb-avatar {
  flex-shrink: 0;
  width: 56px;
  height: 56px;
  border-radius: 50%;
  background: #d9efeb;
  color: #009798;
  font-size: 24px;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
}

.pb-info {
  flex: 1;
  min-width: 0;
}

.pb-name-row {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
}

.pb-name {
  font-size: 26px;
  font-weight: 700;
  color: #304744;
}

.pb-tag {
  padding: 4px 12px;
  border-radius: 8px;
  background: #fff;
  border: 1px solid #cfe5e2;
  color: #009798;
  font-size: 16px;
  font-weight: 600;
}

.pb-sub {
  margin: 8px 0 0;
  font-size: 16px;
  color: #527f77;
}

.pb-status {
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 9px 16px;
  border: 1px solid #f0dcc0;
  border-radius: 10px;
  background: #fdf7e9;
  color: #a07d3a;
  font-size: 16px;
  font-weight: 600;
}

.pb-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #d9a441;
}

/* ========== 资料表 ========== */
.info-table {
  margin-bottom: 22px;
}

.it-head {
  display: grid;
  grid-template-columns: 200px 1fr 260px;
  gap: 16px;
  padding: 0 22px 12px;
}

.it-col {
  min-width: 0;
  word-break: break-all;
}

.it-head .it-col {
  font-size: 16px;
  font-weight: 600;
  color: #a9bcb6;
}

.it-row {
  display: grid;
  grid-template-columns: 200px 1fr 260px;
  gap: 16px;
  align-items: center;
  padding: 18px 22px;
  margin-bottom: 10px;
  border: 1px solid #e9efec;
  border-radius: 14px;
  background: #fbfdfc;
}

.it-row:last-child {
  margin-bottom: 0;
}

.it-row .it-col-name {
  font-size: 16px;
  color: #527f77;
}

.it-row .it-col-value {
  font-size: 18px;
  font-weight: 700;
  color: #304744;
}

.it-row .it-col-desc {
  font-size: 16px;
  color: #9aa8a3;
}

.star-mark {
  color: #b93b2f;
  font-size: 18px;
  margin-left: 4px;
}

/* ========== 行医资格证图片 ========== */
.cert-block {
  display: flex;
  align-items: center;
  gap: 18px;
  padding: 22px 24px;
  border: 1px dashed #cfe5e2;
  border-radius: 18px;
  background: #fbfdfc;
}

.cb-icon {
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  border-radius: 14px;
  background: #e6f4f1;
}

.cb-body {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.cb-title {
  font-size: 18px;
  font-weight: 700;
  color: #304744;
}

.cb-desc {
  font-size: 16px;
  color: #9aa8a3;
}

.cb-btn {
  flex-shrink: 0;
  height: 42px;
  padding: 0 20px;
  border: 1px solid #009798;
  border-radius: 10px;
  background: #fff;
  color: #009798;
  font-family: inherit;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
}

.cb-btn:hover {
  background: #eaf6f4;
}

.cb-btn-muted {
  border-color: #d3e6e3;
  color: #a7b8b4;
}

.cb-btn-muted:hover {
  background: #f5f9f8;
}

/* ========== 卡内底部 ========== */
.panel-foot {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  flex-wrap: wrap;
  margin-top: 22px;
  padding-top: 18px;
  border-top: 1px solid #eef2f0;
}

.foot-note {
  margin: 0;
  font-size: 16px;
  color: #9aa8a3;
}

.foot-tag {
  flex-shrink: 0;
  padding: 8px 16px;
  border-radius: 10px;
  background: #e6f4f1;
  color: #009798;
  font-size: 16px;
  font-weight: 600;
}

/* ========== 底部提示 ========== */
.page-bottom {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  flex-wrap: wrap;
  margin-top: 20px;
}

.bottom-hint {
  margin: 0;
  font-size: 16px;
  color: #9aa8a3;
}

.bottom-back {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  height: 46px;
  padding: 0 22px;
  border: 1px solid #009798;
  border-radius: 12px;
  background: #fff;
  color: #009798;
  font-family: inherit;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
}

.bottom-back:hover {
  background: #eaf6f4;
}

.bottom-back-arrow {
  font-weight: 700;
}

/* ========== 弹窗内容 ========== */
.cert-full {
  width: 100%;
  display: block;
  border-radius: 8px;
}

.no-cert {
  text-align: center;
  padding: 40px;
  color: #9aa8a3;
  font-size: 16px;
}

/* ========== 响应式 ========== */
@media (max-width: 1024px) {
  .it-head,
  .it-row {
    grid-template-columns: 160px 1fr;
  }

  .it-head .it-col-desc,
  .it-row .it-col-desc {
    grid-column: 1 / -1;
  }
}

@media (max-width: 768px) {
  .page-container {
    padding: 20px 16px 32px;
  }

  .hero-row {
    flex-direction: column;
    align-items: flex-start;
    gap: 16px;
  }

  .hero-title {
    font-size: 28px;
  }

  .hero-back {
    width: 100%;
    justify-content: center;
  }

  .panel-card {
    padding: 20px 16px;
    border-radius: 18px;
  }

  .panel-title {
    font-size: 22px;
  }

  .profile-block {
    flex-wrap: wrap;
  }

  .pb-status {
    width: 100%;
    justify-content: center;
  }

  .it-head,
  .it-row {
    grid-template-columns: 1fr;
  }

  .cert-block {
    flex-direction: column;
    align-items: flex-start;
  }

  .cb-btn {
    width: 100%;
  }

  .panel-foot,
  .page-bottom {
    flex-direction: column;
    align-items: flex-start;
  }
}
</style>

<style>
.cert-dialog {
  border-radius: 18px;
}

.cert-dialog .el-dialog__body {
  padding: 16px;
}
</style>
